import { green, blue, yellow, orange, grey } from '@mui/material/colors'

import { COMMON } from 'theme/colors'

export const CONTAINERS_TABS = {
  LIST: 'List',
  MAP: 'Map',
  ACTIVITY: 'Activity',
}

const ALL_CONTAINERS_VIEW = 'all'
const ALL_YARDS_VIEW = 'yards'

type ContainersViewKeyArgs = {
  containerStatus?: string
  yardId?: string
  isAllYardsView?: boolean
}

// 'all' | '<status>' | 'yards' | 'yard.<id>' — the key every per-view preference is stored under
// (filter in localStorage, sort and placeholder visibility in the persisted slice).
export const getContainersViewKey = ({ containerStatus = '', yardId = '', isAllYardsView = false }: ContainersViewKeyArgs = {}) => {
  if (yardId) return `yard.${yardId}`
  if (isAllYardsView) return ALL_YARDS_VIEW

  return containerStatus ? containerStatus.toLowerCase() : ALL_CONTAINERS_VIEW
}

export const COPY_CONTAINER_FIELD_DIRECTION = {
  NAME_TO_SERIAL_NUMBER: 'NAME_TO_SERIAL_NUMBER',
  SERIAL_NUMBER_TO_NAME: 'SERIAL_NUMBER_TO_NAME',
}

export const CONTAINER_STATUS = {
  AVAILABLE: 'AVAILABLE',
  IN_SERVICE: 'IN_SERVICE',
  IN_TRANSIT: 'IN_TRANSIT',
  IN_REPAIR: 'IN_REPAIR',
  ON_ORDER: 'ON_ORDER',
  DECOMMISSIONED: 'DECOMMISSIONED',
}

export const CONTAINER_STATUS_META = {
  [CONTAINER_STATUS.AVAILABLE]: {
    id: CONTAINER_STATUS.AVAILABLE,
    label: 'Available',
    color: green.A700,
  },
  [CONTAINER_STATUS.IN_SERVICE]: {
    id: CONTAINER_STATUS.IN_SERVICE,
    label: 'In Service',
    color: blue[300],
  },
  [CONTAINER_STATUS.IN_TRANSIT]: {
    id: CONTAINER_STATUS.IN_TRANSIT,
    label: 'In Transit',
    color: yellow[300],
  },
  [CONTAINER_STATUS.IN_REPAIR]: {
    id: CONTAINER_STATUS.IN_REPAIR,
    label: 'In Repair',
    color: orange[300],
  },
  [CONTAINER_STATUS.ON_ORDER]: {
    id: CONTAINER_STATUS.ON_ORDER,
    label: 'On Order',
    color: grey[600],
  },
  [CONTAINER_STATUS.DECOMMISSIONED]: {
    id: CONTAINER_STATUS.DECOMMISSIONED,
    label: 'Decommissioned',
    color: COMMON.black,
  },
}
